export default function About() {
  return (
    <section id="about" className="py-16 md:py-24 bg-background-50">
      <div className="w-full max-w-[1000px] mx-auto px-4 md:px-6">
        <div className="flex flex-col lg:flex-row items-center gap-10 lg:gap-16">
          <div className="flex-shrink-0 w-full max-w-[400px]">
            <div className="aspect-[4/3] rounded-2xl overflow-hidden bg-background-200">
              <img
                src="https://readdy.ai/api/search-image?query=Modern%20home%20theater%20setup%20with%20warm%20ambient%20lighting%2C%20large%20screen%20displaying%20cinematic%20content%2C%20cozy%20living%20room%20atmosphere%2C%20coral%20and%20golden%20accent%20decor%2C%20entertainment%20lifestyle%20scene&width=800&height=600&seq=mitao-about-image&orientation=landscape"
                alt="密桃视频观影体验"
                className="w-full h-full object-cover"
                loading="lazy"
              />
            </div>
          </div>

          <div className="flex-1 text-center lg:text-left">
            <div className="inline-flex items-center gap-2 px-4 py-1.5 rounded-full bg-secondary-100 text-secondary-700 text-xs font-medium mb-4">
              <i className="ri-information-line"></i>
              <span>平台介绍</span>
            </div>
            <h2 className="text-2xl md:text-4xl font-heading font-bold text-foreground-950">
              关于我们
            </h2>
            <p className="text-sm md:text-base text-foreground-600 mt-4 leading-relaxed">
              密桃视频是一个专注于影视内容聚合的在线观影平台。
              我们致力于聚合红桃视频、樱桃视频、茄子视频、糖心视频等热门站点的优质高清资源，
              为用户提供一站式免费在线观看体验。
            </p>
            <p className="text-sm md:text-base text-foreground-600 mt-3 leading-relaxed">
              平台涵盖最新电影、热播电视剧、综艺娱乐、动漫番剧、纪录片等多种类型内容，
              每日同步更新热门片源，支持多种画质选择和智能线路切换，
              让每一位用户都能享受流畅不缓冲的高清观影乐趣。
            </p>
            <div className="flex flex-wrap items-center justify-center lg:justify-start gap-6 mt-6">
              <div className="flex items-center gap-2">
                <div className="w-8 h-8 rounded-lg bg-accent-100 flex items-center justify-center">
                  <i className="ri-user-smile-line text-accent-500"></i>
                </div>
                <span className="text-sm text-foreground-700">服务用户 50万+</span>
              </div>
              <div className="flex items-center gap-2">
                <div className="w-8 h-8 rounded-lg bg-primary-100 flex items-center justify-center">
                  <i className="ri-film-line text-primary-500"></i>
                </div>
                <span className="text-sm text-foreground-700">片库总量 10万+</span>
              </div>
              <div className="flex items-center gap-2">
                <div className="w-8 h-8 rounded-lg bg-secondary-100 flex items-center justify-center">
                  <i className="ri-calendar-check-line text-secondary-500"></i>
                </div>
                <span className="text-sm text-foreground-700">稳定运营 3年+</span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}